module.exports = __webpack_public_path__ + "img/c1-tit1.9f08d1ae.png";